import { render } from "./PhoneField.vue?vue&type=template&id=132274b6"
import script from "./PhoneField.vue?vue&type=script&lang=ts"
export * from "./PhoneField.vue?vue&type=script&lang=ts"
script.render = render

export default script